/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'snmp-trap';
const componentName = 'snmp-trap-profile-list-modal';
const prefix = `${moduleName}.${componentName}`;

export const editSnmpTrapServerHeader = `${prefix}.editSnmpTrapServerHeader`;
export const newSnmpTrapServerHeader = `${prefix}.newSnmpTrapServerHeader`;
export const trapServerAddressLabel = `${prefix}.trapServerAddressLabel`;
export const trapServerAddressPlaceholder = `${prefix}.trapServerAddressPlaceholder`;
export const snmpCommunityLabel = `${prefix}.snmpCommunityLabel`;
export const snmpCommunityPlaceholder = `${prefix}.snmpCommunityPlaceholder`;
export const snmpVersionLabel = `${prefix}.snmpVersionLabel`;
export const snmpVersionPlaceholder = `${prefix}.snmpVersionPlaceholder`;
export const authPassphraseLabel = `${prefix}.authPassphraseLabel`;
export const authPassphrasePlaceholder = `${prefix}.authPassphrasePlaceholder`;
export const privacySettingsLabel = `${prefix}.privacySettingsLabel`;
export const privacySettingsPlaceholder = `${prefix}.privacySettingsPlaceholder`;
export const privacyPassphraseLabel = `${prefix}.privacyPassphraseLabel`;
export const privacyPassphrasePlaceholder = `${prefix}.privacyPassphrasePlaceholder`;
export const authTypeLabel = `${prefix}.authTypeLabel`;
export const authTypePlaceholder = `${prefix}.authTypePlaceholder`;

export const ENGLISH = {
    [editSnmpTrapServerHeader]: 'Edit SNMP Trap Server',
    [newSnmpTrapServerHeader]: 'New SNMP Trap Server',
    [trapServerAddressLabel]: 'Trap Server IP(v4/v6) Address or FQDN',
    [trapServerAddressPlaceholder]: 'Enter Trap Server IP(v4/v6) Address or FQDN',
    [snmpCommunityLabel]: 'SNMP Community',
    [snmpCommunityPlaceholder]: 'Enter SNMP Community',
    [snmpVersionLabel]: 'SNMP Version',
    [snmpVersionPlaceholder]: 'Select SNMP Version',
    [authPassphraseLabel]: 'Auth Passphrase',
    [authPassphrasePlaceholder]: 'Enter Auth Passphrase',
    [privacySettingsLabel]: 'Privacy Settings',
    [privacySettingsPlaceholder]: 'Select Privacy Settings',
    [privacyPassphraseLabel]: 'Privacy Passphrase',
    [privacyPassphrasePlaceholder]: 'Enter Privacy Passphrase',
    [authTypeLabel]: 'Auth Type',
    [authTypePlaceholder]: 'Select Auth Type',
};
